export enum Partner {
    AgTrax = 1,
    Barchart = 2,
    DTN = 4,
    Oakland = 5,
    Agris = 6,
    Agvance = 7,
    EverAg = 8,
    AgVantage = 9,
    AgVision = 10,
    AgTech = 11,
    Intellego = 12,
    Vertical = 13,
    AgrisDataHub = 14
}

export function getPartnerName(partner: Partner): string {
    return Partner[partner] ?? "Unknown import system";
}